const useAccessLocation = () => {
  let accessLocation = 'school';

  if (localStorage.getItem('accessLocation') === 'home') {
    accessLocation = 'home';
  }

  return { accessLocation };
};

export default useAccessLocation;
